package repdb

import com.ustadmobile.door.DoorDbType
import com.ustadmobile.door.EntityInsertionAdapter
import com.ustadmobile.door.PreparedStatementConfig
import com.ustadmobile.door.ext.prepareAndUseStatement
import com.ustadmobile.door.jdbc.PreparedStatement
import com.ustadmobile.door.jdbc.ext.mapNextRow
import com.ustadmobile.door.jdbc.ext.useResults
import com.ustadmobile.door.room.RoomDatabase
import kotlin.Boolean
import kotlin.Long
import kotlin.String

public class CompositePkDao_JdbcImpl(
  public val _db: RoomDatabase,
) : CompositePkDao() {
  public val _insertAdapterCompositePkEntity_abort: EntityInsertionAdapter<CompositePkEntity> =
      object : EntityInsertionAdapter<CompositePkEntity>(_db) {
    override fun makeSql(returnsId: Boolean): String =
        "INSERT INTO CompositePkEntity (code1, code2, name) VALUES(?, ?, ?)"

    override fun bindPreparedStmtToEntity(stmt: PreparedStatement, entity: CompositePkEntity) {
      stmt.setLong(1, entity.code1)
      stmt.setLong(2, entity.code2)
      stmt.setString(3, entity.name)
    }
  }

  override fun insert(entity: CompositePkEntity) {
    _insertAdapterCompositePkEntity_abort.insert(entity)
  }

  override fun update(entity: CompositePkEntity) {
    val _sql = "UPDATE CompositePkEntity SET name = ? WHERE code1 = ? AND code2 = ?"
    _db.prepareAndUseStatement(_sql) {
       _stmt ->
      _stmt.setString(1, entity.name)
      _stmt.setLong(2, entity.code1)
      _stmt.setLong(3, entity.code2)
      _stmt.executeUpdate()
    }
  }

  override fun delete(entity: CompositePkEntity) {
    var _numChanges = 0
    _db.prepareAndUseStatement("DELETE FROM CompositePkEntity WHERE code1 = ? AND code2 = ?") {
       _stmt ->
      _stmt.setLong(1, entity.code1)
      _stmt.setLong(2, entity.code2)
      _numChanges += _stmt.executeUpdate()
    }
  }

  override fun findByPKs(code1: Long, code2: Long): CompositePkEntity? =
      _db.prepareAndUseStatement(PreparedStatementConfig(
    sql = """
    |
    |        SELECT CompositePkEntity.* 
    |          FROM CompositePkEntity
    |         WHERE CompositePkEntity.code1 = CAST(? AS BIGINT) AND CompositePkEntity.code2 = CAST(? AS BIGINT) 
    |    
    """.trimMargin(),
    postgreSql = """
    |
    |        SELECT CompositePkEntity.* 
    |          FROM CompositePkEntity
    |         WHERE CompositePkEntity.code1 = ? AND CompositePkEntity.code2 = ? 
    |    
    |""".trimMargin(),
    readOnly = true,)
  ) { _stmt -> 
    _stmt.setLong(1,code1)
    _stmt.setLong(2,code2)
    _stmt.executeQuery().useResults{ _result -> 
      _result.mapNextRow(null) {
        val _tmp_code1 = _result.getLong("code1")
        val _tmp_code2 = _result.getLong("code2")
        val _tmp_name = _result.getString("name")
        CompositePkEntity().apply {
          this.code1 = _tmp_code1
          this.code2 = _tmp_code2
          this.name = _tmp_name
        }
      }
    }
  }
}
